import { render, staticRenderFns } from "./dhShare.vue?vue&type=template&id=336cd56e&"
import script from "./dhShare.vue?vue&type=script&lang=js&"
export * from "./dhShare.vue?vue&type=script&lang=js&"
import style0 from "./dhShare.vue?vue&type=style&index=0&id=336cd56e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports